import { Alert } from '@vtex/shoreline'

import Panel from '~/components/Panel'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import ProductsPanel from '~/modules/retailMedia/components/ProductsPanel'

type ProductsSectionProps = {
  hasRetailer: boolean
  initialCollapsibleState?: boolean
  formRef: React.ComponentProps<typeof ProductsPanel>['formRef']
  publisherId: React.ComponentProps<typeof ProductsPanel>['publisherId']
}

// Products are searched in the destination retailer's catalog, so there is
// nothing to search before one is chosen.
const ProductsSection: React.FC<ProductsSectionProps> = ({
  hasRetailer,
  initialCollapsibleState,
  formRef,
  publisherId
}) => {
  const { t } = useAPPTranslation()

  if (!hasRetailer) {
    return (
      <Panel
        title={t('rm:ProductsPanel.title')}
        description={t('rm:campaign.create.ProductsPanel.description.relate')}
        isCollapsible
        initialCollapsibleState={initialCollapsibleState}
      >
        <Alert variant="warning">
          {t('rm:campaign.create.ProductsPanel.destinationRetailerRequired')}
        </Alert>
      </Panel>
    )
  }

  return (
    <ProductsPanel
      formRef={formRef}
      description={t('rm:campaign.create.ProductsPanel.description.relate')}
      publisherId={publisherId}
      initialCollapsibleState={initialCollapsibleState}
      // "This publisher operates more than one brand — campaigns will run
      // on the following brands" doesn't apply here: offsite targets a
      // single destination retailer (1:1), and there's no way to dispatch
      // per-brand links to Publya. Leftover from the previous flow, which
      // never replaced the message when the context changed (SPEC 004 item 2.2).
      hideBrandsPanel
    />
  )
}

export default ProductsSection
